import React, { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { fetchExternalClientDetails, checkIsWBSEValid } from "../../../redux/fui/index";
import { checkRootExisted } from "../../../redux/fui";
import {
    StyledTooltip, StyledRadioGroup,
    TopRadioWrapper,
    ConfigurationFormLabel,
} from "../FuiStyles";
import { longTextEndDate, rootExistedHint, rootWrongFormatHint } from "../Constants/LongText";
import { useDebounce } from "../../../helper/customizedHooks";
import { DateTextFieldCommonComponent, DateTextFieldCommonComponentv2 } from "../DateTextFieldCommonComponent/DateTextFieldCommonComponent";
import * as FormField from "./IndividualFormFields";
import * as FormField2 from "./GenwizardFormFields";
import * as PlatformFormField from "./IndividualFormFields";
import { checkServiceNowTicket, checkRITM, checkOpportunityID, checkWBSECode, checkPOCname, createMaxDate, checkServerStatus } from "./CommonFunctions";
import GeneralForm from "./GeneralForm";
import * as fuiRedux from "../../../redux/fui/index";
import { Grid, FormControlLabel, Radio, DialogActions, FormLabel, Checkbox, FormGroup, TextField } from "@material-ui/core";
import { CommonDialogV2 } from "../../common/CommonComponents/Dialog";
import { AcceptButton2 } from "../../common/CommonComponents/Buttons";
import ValidationDialog from './ValidationDialog';
import useFormValidationWithBorders from './useFormValidationWithBorders';
import { useRef } from "react";

/**
 * Turing Form
 * @author ganesh.gugulothu
 * @version 2.0
 * @see Used in component: PlatformLicenseStepper
 *
 * Agent config field mapping (rebuilt against AOPS.xlsx — columns:
 * TRA, CMA, RCA onprem, RCA serverless, OID onprem, OID serverless):
 */

const AutonomousOps = ({
    values, // the value would be changed by user's input
    updateAOPForm, //the function to update DPForm values which is from redux
    createdBy, // user's EID
    checkDomainAvaliable, // the function that check whether DomainContextRoot exist or not from redux
    isRootExist, // the value that show whether DomainContextRoot exist or not from redux
    setIsAllValid, // the function to check whether all validations are satisfieds
    selectedEnvironment,
    minDate,
    maxDate,
    isServiceEndDateInvalid,
    getSelectedEnvironment,
    getServiceEndDate,
    getNotesValue,
    notesValidations,
    configurationType,
    classes,
    history,
    email,
    idToken,
    isExternalClientLoading,
    externalClientData,
    externalClientError,
    fetchExternalClientDetails,
    isLoading,
    formClickSubmit,
    checkIsWBSEValid,
    isWBSEValid, // this value shows whether the WBSE is valid or not from redux
}) => {
    // keychange event
    const timeoutRef = useRef();

    // open the dialog when user choose Yes in GDPR
    const config = configurationType === "quick";
    //check whether RITM is valid
    const [isRITMValid, setIsRITMValid] = useState(true);
    const [ritmAPIValidation, setRITMAPIValidation] = useState(null);

    //check whether OpportunityID is valid
    const [isOpportunityIDValid, setIsOpportunityIDValid] = useState(true);
    const [opportunityAPIValidation, setOpportunityAPIValidation] = useState(null);
    const [ttpword, setTtpword] = useState({
        'ADO': false,
        'JIRA': false,
    });
    // check whether WBSECode and MonthlyTicketVolume are valid
    const [isWBSECodeValid, setIsWBSECodeValid] = useState(true);
    const [isProjectNameValid, setIsProjectNameValid] = useState(true);

    const [isDialogFlowDevToken, setIsDialogFlowDevToken] = useState(false);

    const [isDialogFlowClientToken, setIsDialogFlowClientToken] = useState(false);
    const isGDPR = values.GDPR === "yes";
    const isOpenAI = values.OpenAI === "True";
    const isAAAMTermsConditions = values.AAAMTermsConditions === "yes";
    const isDialogFlow = values.DialogFlow === "enabled";
    const isDedicated = values.InstanceType === history.location.state.InstanceType;
    const [isNoteVisible, setNoteVisible] = useState(true);

    const instanceType = "Container";
    const Tier = instanceType && instanceType == "Container" ? values.Tier === '' ? 'gold' : values.Tier : values.Tier

    const [sapContractCodeLength, setSapContractCodeLength] = useState("0");
    const [domainContextRoot, setDomainContextRoot] = useState("[__]");
    const [regionCode, setRegionCode] = useState("[__]");
    const [errorADGroup, setErrorADGroup] = useState(false);
    const [errorSADGroup, setErrorSADGroup] = useState(false);
    const [isADSADUnique, setIsADSADUnique] = useState(false);
    const [customURL, setCustomURL] = useState("https://[__].mywizard-aiops.accenture.com/[__]");
    const [isTeamNameSelected, setIsTeamNameSelected] = useState(true);
    const [env, setEnv] = useState("");
    const [isPocvalid, setPocvalid] = useState(true);
    const [isPlanInputValid, setIsPlanInputValid] = useState(false);
    const [isChecked, setIsChecked] = useState(true);
    const [cuiEndpointValid, setCuiEndpointValid] = useState(false);
    const [kmEndpointValid, setKmEndpointValid] = useState(false);
    const [amEndpointValid, setAmEndpointValid] = useState(false);
    const [isChecking, setIsChecking] = useState({
        cuiendpoint: false,
        kmendpoint: false,
        amendpoint: false,
    })

    // Show/hide state for every masked (password/API-key) field, keyed by
    // field name. Each AO*Password / AO*Apikey function in
    // GenwizardFormFields.js expects (showPassword, handleShowPassword) as
    // its 3rd/4th args to drive its eye-icon toggle — this is the single
    // source of truth for all of them.
    const [showPassword, setShowPassword] = useState({});
    const toggleShowPassword = (key, val) => {
        setShowPassword((prev) => ({ ...prev, [key]: val }));
    };

    const { validationErrors, showValidationDialog, closeDialog, handleValidationResult } = useFormValidationWithBorders(values, isWBSEValid, selectedEnvironment);

    const handleContractAvailabilityChange = (event) => {
        const value = event.target.value;
        setIsChecked(value === "yes");
        if (value === "no") {
            updateAOPForm("IsContractIdAvailable", "no");
            updateAOPForm("SAPContractID", "0000000000");
            updateAOPForm("EndToEndUId", "");
            updateAOPForm("ContractAvailabilityDate", createMaxDate(14));
            setSapContractCodeLength(10)
            setPocvalid(false);
        } else {
            setPocvalid(true);
            updateAOPForm("SAPContractID", "")
            updateAOPForm("ClientName", "")
            updateAOPForm("EndToEndUId", "")
            setSapContractCodeLength(0)
        }
    };


    useEffect(() => {
        if (config) {
            setDomainContextRoot("[__]");
            setRegionCode("[__]");
        }
    }, [config]);
    if (config) {
        updateAOPForm("EndToEndUId", "")
        updateAOPForm("Company", "")
        updateAOPForm("AvanadeCountry", "")
        updateAOPForm("AccentureCountry", "")
        updateAOPForm("InstanceType", "Container")
        updateAOPForm("Tier", Tier)
        updateAOPForm("ContractAvailabilityDate", "")
    }

    if (!config) {
        if (externalClientData.length > 0) {
            updateAOPForm("ClientName", externalClientData[0])
            updateAOPForm("EndToEndUId", externalClientData[1])
            updateAOPForm("InstanceType", "Container")
            updateAOPForm("Tier", Tier)
            if (externalClientData[2] !== undefined)
                updateAOPForm("Company", externalClientData[2])
            if (externalClientData[3] !== undefined)
                updateAOPForm("AvanadeCountry", externalClientData[3])
            if (externalClientData[4] !== undefined)
                updateAOPForm("AccentureCountry", externalClientData[4])
            if (isChecked && externalClientData[5] !== undefined)
                updateAOPForm("GDPR", externalClientData[5] ? "yes" : "no")
            updateAOPForm("ContractAvailabilityDate", "")
            updateAOPForm("IsContractIdAvailable", "yes")
        } else {
            updateAOPForm("InstanceType", "Container")
            updateAOPForm("Tier", Tier)
        }
    }

    setIsAllValid(true);

    const handleChangeRoot = (event, fieldName) => {
        const re = /^[a-z0-9]*$/;
        const value = event.target.value;
        re.test(value) && updateAOPForm(fieldName, value);
        setDomainContextRoot(value)
    };
    const handleChangeRootSuggestions = (event, value, fieldName) => {
        const re = /^[a-z0-9]*$/;
        re.test(value) && updateAOPForm(fieldName, value);
        setDomainContextRoot(value)
    };

    // get user's input
    const handleChange = (event, fieldName) => {
        if (fieldName === "TentativeServiceEndDate" || fieldName === "ContractAvailabilityDate") {
            updateAOPForm(fieldName, event);
            getServiceEndDate(event);
        } else if (fieldName === "TeamName") {
            if (event !== undefined || event !== null) {
                updateAOPForm(fieldName, event);
                setIsTeamNameSelected(true);
                if (values.TeamName !== "Others") {
                    updateAOPForm("TeamNameOthers", "")
                }
            } else {
                setIsTeamNameSelected(false);
            }
        } else {
            const { value } = event.target;
            event.preventDefault();
            updateAOPForm(fieldName, value);
            if (fieldName === "WBSEcode") {
                const isWBSEFormatValid = checkWBSECode(value);
                if (isWBSEFormatValid) {
                    checkIsWBSEValid(value)
                }
            }
            if (fieldName === "Pocdetails") {
                setPocvalid(checkPOCname(value));
            }
            if (fieldName === "ProjectName") {
                if (value.length > 32 || value.length < 3) {
                    setIsProjectNameValid(false)
                } else {
                    setIsProjectNameValid(true)
                }
            }
            if (fieldName === "RITM") {
                setIsRITMValid(checkRITM(value));
            }
            if (fieldName === "OpportunityID") {
                setIsOpportunityIDValid(checkOpportunityID(value));
            }
            if (fieldName === "DialogFlowDevToken") {
                if (value.length > 0) {
                    setIsDialogFlowDevToken(true);
                } else {
                    setIsDialogFlowDevToken(false);
                }
            }
            if (fieldName === "DialogFlowClientToken") {
                if (value.length > 0) {
                    setIsDialogFlowClientToken(true);
                } else {
                    setIsDialogFlowClientToken(false);
                }
            }
            if (fieldName === "Environment") {
                getSelectedEnvironment(value);
            }
            if (fieldName === "TentativeServiceEndDate") {
                getServiceEndDate(value);
            }
            if (fieldName === "AdminDistributionGroup") {
                if (value == values.SuperAdminDistributionGroup) {
                    setIsADSADUnique(true)
                } else {
                    setIsADSADUnique(false)
                }
                if (value.includes(",") || value.includes(";") || value.includes(" ") || value.includes("@")) {
                    setErrorADGroup(true)
                } else {
                    setErrorADGroup(false)
                }
            }
            if (fieldName === "SuperAdminDistributionGroup") {
                if (value == values.AdminDistributionGroup) {
                    setIsADSADUnique(true)
                } else {
                    setIsADSADUnique(false)
                }
                if (value.includes(",") || value.includes(";") || value.includes(" ") || value.includes("@")) {
                    setErrorSADGroup(true)
                } else {
                    setErrorSADGroup(false)
                }
            }
            if (fieldName === "RequestNotes") {
                if (value.length > 0 && value.length < 247) {
                    getNotesValue({ emptyString: false, maxLength: false });
                } else if (value.length === 0) {
                    getNotesValue({ emptyString: true, maxLength: false });
                } else if (value.length > 246) {
                    getNotesValue({ emptyString: false, maxLength: true });
                }
            }
            if (fieldName === "SAPContractID") {
                let sapLength = value.length
                setSapContractCodeLength(sapLength)
                if (sapLength == 10) {
                    fetchExternalClientDetails(value)
                }
            }
            if (fieldName === "Agent") {
                let appcore = values.Agent;
                const appName = event.target.name;
                if (appcore.includes(appName)) {
                    appcore = appcore.filter(item => item !== appName);
                } else {
                    appcore.push(appName);
                }
                updateAOPForm(fieldName, appcore);
            }
            if ([
                "CUIConfig", "IMConfig", "KMConfig", "AMConfig", "TicketSourceConfig",
                "ServiceNowConfig", "SnowConfig", "SplunkConfig", "ArtifactStorage",
                "CMDBLiteConfig", "DatadogConfig", "DynatraceConfig",
                "ElasticSearchConfig", "OIDConfig", "SLOConfig",
                "VenafiConfig", "AWXConfig",
            ].includes(fieldName)) {
                const tid = event.target.id;
                let ConfigVal = values[fieldName]
                ConfigVal[tid] = value;
                updateAOPForm(fieldName, ConfigVal);
            }
            if (fieldName === "RCA") {
                const tid = event.target.id;
                let ConfigVal = values.RCA
                ConfigVal[tid] = value;
                updateAOPForm(fieldName, ConfigVal);
            }

            if (fieldName === "GDPR" && value === "yes") {
                updateAOPForm("DeploymentRegion", "");
            }
            if (fieldName === "DeploymentRegion") {
                if (value == "sydney") {
                    setRegionCode("dhuat")
                } else if (value == "virginia") {
                    setRegionCode("dh1uat")
                } else if (value == "frankfurt") {
                    setRegionCode("dh2uat")
                } else if (value == "singapore") {
                    setRegionCode("dh3uat")
                } else if (value == "tokyo") {
                    setRegionCode("dh4uat")
                } else if (value == "ireland") {
                    setRegionCode("dh5uat")
                } else if (value == "london") {
                    setRegionCode("dh6uat")
                } else {
                    setRegionCode("[__]")
                }
            }
            if (fieldName === "DataClassification") {
                if (value === "Client-Production" || value === "Internal-Production") {
                    setEnv("Production")
                } else if (value === "Client-NonProduction") {
                    setEnv("Test")
                } else if (value === "AppTeam-Development") {
                    setEnv("Dev")
                    updateAOPForm("Tier", "")
                } else if (value === "AppTeam-Testing") {
                    setEnv("Test")
                    updateAOPForm("Tier", "")
                } else {
                    setEnv("")
                    updateAOPForm("Tier", "")
                }
            }
        }
    };

    updateAOPForm("ConfigurationType", configurationType);
    getSelectedEnvironment(env);
    updateAOPForm("Environment", env);
    const debouncedValue = useDebounce(domainContextRoot, 300);
    useEffect(() => {
        debouncedValue && checkDomainAvaliable(debouncedValue);
    }, [debouncedValue]);

    const EndpointChecking = (setEnpointValid, endpointName, endpointValue) => {
        clearTimeout(timeoutRef.current);
        timeoutRef.current = setTimeout(() => {
            const bakes = {};
            bakes[endpointName] = true;
            setIsChecking({ ...isChecking, ...bakes })
            const checkvalid = async () => {
                const siteStatus = await checkServerStatus(endpointValue);
                setEnpointValid(siteStatus);
                bakes[endpointName] = false;
                setIsChecking({ ...isChecking, ...bakes })
            }
            checkvalid();
        }, 1000);
    }
    useEffect(() => {
        if (!values.CUIConfig['URL'])
            return;
        EndpointChecking(setCuiEndpointValid, "cuiendpoint", values.CUIConfig['URL'])
        return () => clearTimeout(timeoutRef.current);
    }, [values.CUIConfig['URL']]);
    useEffect(() => {
        if (!values.KMConfig['URL'])
            return;
        EndpointChecking(setKmEndpointValid, "kmendpoint", values.KMConfig['URL'])
        return () => clearTimeout(timeoutRef.current);
    }, [values.KMConfig['URL']]);
    useEffect(() => {
        if (!values.AMConfig['URL'])
            return;
        EndpointChecking(setAmEndpointValid, "amendpoint", values.AMConfig['URL'])
        return () => clearTimeout(timeoutRef.current);
    }, [values.AMConfig['URL']]);

    //form validation
    const validateInputFields = (step) => {
        if (step !== 'submit') {
            return true;
        }

        let ispass = true;
        const missingFields = [];

        const allFieldsRequired = [
            'ProjectName',
            'WBSEcode',
            'SecondaryPOC',
            'DataClassification',
            'TeamName',
            'RequestNotes',
            'DeploymentRegion',
            //'DomainContextRoot',
            'Environment',
            'AdminDistributionGroup',
            'TentativeServiceEndDate'
        ];

        if (!config) {
            if (isChecked)
                allFieldsRequired.push('SAPContractID');
            else
                allFieldsRequired.push('Pocdetails', 'ClientName');

            allFieldsRequired.push('RITM');
        } else {
            allFieldsRequired.push('RITM');
        }

        // if (isOpenAI) {
        //     allFieldsRequired.push(
        //         'ChatGPT',
        //         'OpenAITextEmbeddingsModel'
        //     );
        // }

        if (isDialogFlow) {
            allFieldsRequired.push('DialogFlowDevToken', 'DialogFlowClientToken');
        }

        const agentWrapper = document.getElementById('Genwizard_agent_wrapper');
        if (!values.Agent || values.Agent.length === 0) {
            if (agentWrapper) {
                agentWrapper.style.outline = "1px solid #E20000";
                agentWrapper.style.outlineOffset = "-1px";
                agentWrapper.style.borderRadius = "4px";
            }
            missingFields.push('Agent selection (required when AD is selected)');
            ispass = false;
        } else {
            if (agentWrapper) agentWrapper.style.outline = "";
        }

        for (const fieldname of allFieldsRequired) {
            if (fieldname === "WBSEcode") {
                if (!values[fieldname] || values[fieldname] === "" || !isWBSEValid) {
                    missingFields.push(fieldname);
                    ispass = false;
                }
            } else if (fieldname === "RITM") {
                if (!values.RITM || values.RITM === "" || values.RITM === null) {
                    missingFields.push(fieldname);
                    ispass = false;
                } else if (ritmAPIValidation === false) {
                    missingFields.push(`${fieldname} (not found in records)`);
                    ispass = false;
                } else if (!isRITMValid) {
                    missingFields.push(`${fieldname} (invalid format)`);
                    ispass = false;
                }
            } else if (fieldname === "OpportunityID") {
                if (values.OpportunityID && values.OpportunityID !== "" && values.OpportunityID !== null) {
                    if (opportunityAPIValidation === false) {
                        missingFields.push(`${fieldname} (not found in records)`);
                        ispass = false;
                    } else if (!isOpportunityIDValid) {
                        missingFields.push(`${fieldname} (invalid format)`);
                        ispass = false;
                    }
                }
            } else if (fieldname === 'DialogFlowDevToken' || fieldname === 'DialogFlowClientToken') {
                if (values['DialogFlowDevToken'] === "" && values['DialogFlowClientToken'] === "") {
                    missingFields.push('DialogFlow Token (either Dev or Client token required)');
                    ispass = false;
                }
            } else if (fieldname === "TentativeServiceEndDate" && (!selectedEnvironment || selectedEnvironment === "")) {
                missingFields.push(fieldname);
                ispass = false;

            } else if (fieldname === "Pocdetails") {
                if (values['Pocdetails'] === "" || !isPocvalid && values['Pocdetails'] !== "") {
                    missingFields.push(fieldname);
                    ispass = false;
                }
            }
            else if (values[fieldname] === "" || values[fieldname] === undefined || values[fieldname] === null) {
                missingFields.push(fieldname);
                ispass = false;
            }
        }

        handleValidationResult(ispass, missingFields, formClickSubmit);
        return ispass;
    }

    // Agent selection flags, and Agent Manager field visibility rules per the
    // sheet: TRA and CMA each have a single column (no onprem/serverless
    // split), so they always need the AM API key and never show the
    // Type toggle. RCA and OID each have separate onprem/serverless
    // columns — the API key is only required in serverless mode, so the
    // Type toggle only needs to appear when one of them is selected.
    const hasAnyAgent = values.Agent.length > 0;
    const isTRA = values.Agent.includes('TRA');
    const isRCA = values.Agent.includes('RCA');
    const isOID = values.Agent.includes('OID');
    const isCMA = values.Agent.includes('CMA');
    const showAmDeploymentType = isRCA || isOID;
    const amIsServerless = (values.AMConfig.Type || "onprem") === "serverless";
    const showAmApiKey = isTRA || isCMA || ((isRCA || isOID) && amIsServerless);

    return (
        <>
            <GeneralForm
                isPlanInputValid={isPlanInputValid}
                FormId={15}
                validateInputFields={validateInputFields}
                formClickSubmit={formClickSubmit}
                ClientContractFields={

                    <div>
                        {!config ?
                            <TopRadioWrapper>
                                <ConfigurationFormLabel component="legend">
                                    Is a Contract ID available?
                                </ConfigurationFormLabel>


                                <StyledRadioGroup
                                    aria-label="contract-available"
                                    name="contract-available"
                                    value={isChecked ? "yes" : "no"}
                                    onChange={handleContractAvailabilityChange}
                                    row
                                >
                                    <FormControlLabel
                                        value="yes"
                                        control={<Radio color="primary" />}
                                        label="YES"
                                    />
                                    <FormControlLabel
                                        value="no"
                                        control={<Radio color="primary" />}
                                        label="NO"
                                    />
                                </StyledRadioGroup>
                            </TopRadioWrapper>
                            : ""}

                        {(!isChecked && !config) &&
                            <div style={{ fontSize: "small", color: "#0041F0" }}>
                                <em>
                                    To proceed with provisioning without a Contract ID, please provide the following mandatory details
                                </em>
                                <ul>
                                    <li>WBSE Code (used for chargeback if contract is not provided)</li>
                                    <li>Opportunity ID (for deal tracking and reference)</li>
                                    <li>Expected Contract Availability Date (must be within 42 days)</li>
                                    <li>Client Point of Contact (name and email for contract follow-up)</li>
                                </ul>
                            </div>
                        }
                        <div style={{ flexGrow: 1 }}>
                            <Grid
                                container
                                spacing={2}
                            >
                                {(!config && isChecked) ?
                                    <Grid item xs={4}>
                                        {PlatformFormField.SAPContractIDPlatformField(values, handleChange, externalClientError, isExternalClientLoading, sapContractCodeLength)}
                                    </Grid>
                                    : (!config && !isChecked) ?
                                        <Grid item xs={4}>
                                            {FormField.Pocvalid(handleChange, values, isPocvalid)}
                                        </Grid>
                                        : <></>
                                }

                                {(!config &&
                                    isChecked &&
                                    sapContractCodeLength === 10 &&
                                    !isExternalClientLoading &&
                                    !externalClientError) &&
                                    <Grid item xs={4}>
                                        {PlatformFormField.ClientNamePlatformField(
                                            values,
                                            handleChange,
                                            externalClientData[0]
                                        )}
                                    </Grid>
                                }
                                {!config &&
                                    isChecked &&
                                    sapContractCodeLength === 10 &&
                                    !isExternalClientLoading &&
                                    !externalClientError && (
                                        <Grid item xs={4}>
                                            {PlatformFormField.EndToEndUIdPlatformField(
                                                values,
                                                handleChange,
                                                externalClientData[1]
                                            )}
                                        </Grid>
                                    )
                                }
                                {(!config && !isChecked) &&
                                    <Grid item xs={4}>
                                        <StyledTooltip
                                            title={longTextEndDate}
                                            placement="left-start"
                                            noValidate
                                        >
                                            <DateTextFieldCommonComponentv2
                                                tentativeServiceEndDate={values.ContractAvailabilityDate}
                                                minDate={0}
                                                maxDate={createMaxDate(27)}
                                                handleChange={handleChange}
                                                idkey="ContractAvailabilityDate"
                                                label="Contract Availability Date"
                                            />
                                        </StyledTooltip>
                                    </Grid>
                                }
                                {(!config) &&
                                    <>
                                        <Grid item xs={4}>
                                            <FormField.RITMField
                                                values={values}
                                                handleChange={handleChange}
                                                isRITMValid={isRITMValid}
                                                apiValidation={ritmAPIValidation}
                                                setAPIValidation={setRITMAPIValidation}
                                                configurationType={configurationType}
                                            />
                                        </Grid>
                                        <Grid item xs={4}>
                                            <FormField.OpportunityIDField
                                                values={values}
                                                handleChange={handleChange}
                                                isOpportunityIDValid={isOpportunityIDValid}
                                                apiValidation={opportunityAPIValidation}
                                                setAPIValidation={setOpportunityAPIValidation}
                                                configurationType={configurationType}
                                            />
                                        </Grid>
                                    </>
                                }
                                {(!config && !isChecked) &&
                                    <Grid item xs={4}>
                                        {FormField.ClientNamePlatformInternal(handleChange, values)}
                                    </Grid >}
                                <Grid item xs={4}>
                                    {FormField.ProjectNameField(handleChange, values, isProjectNameValid)}
                                </Grid>

                                {config &&
                                    <Grid item xs={8}>
                                        <FormField.RITMField
                                            values={values}
                                            handleChange={handleChange}
                                            isRITMValid={isRITMValid}
                                            apiValidation={ritmAPIValidation}
                                            setAPIValidation={setRITMAPIValidation}
                                            configurationType={configurationType}
                                        />
                                    </Grid>
                                }
                                <Grid item xs={4}>
                                    {FormField.WBSECodeField(handleChange, values, isWBSECodeValid, isWBSEValid, isLoading)}
                                </Grid >
                                <Grid item xs={4}>
                                    {FormField.SecondaryContact(handleChange, values, config)}
                                </Grid>
                                <Grid item xs={4}>
                                    {FormField.DataClassificationField(handleChange, values, configurationType)}
                                </Grid>
                                {!config && (
                                    <Grid item xs={4}>
                                        {FormField.DeploymentPhaseField(handleChange, values, env)}
                                    </Grid>
                                )}

                                <Grid item xs={4}>
                                    {FormField.TeamNamesField(handleChange, values, isTeamNameSelected, 'gtaad', configurationType, instanceType)}
                                </Grid >
                                {values.TeamName === "Others" &&
                                    <Grid item xs={4}>
                                        {FormField.TeamNameOthers(handleChange, values)}
                                    </Grid >
                                }
                                {
                                    (config &&
                                        <Grid item xs={4}>
                                            {FormField.ClientNamePlatformInternal(handleChange, values)}
                                        </Grid>
                                    )
                                }
                                <Grid item xs={12}>
                                    {PlatformFormField.RequestNotesPlatformField(
                                        values,
                                        handleChange,
                                        notesValidations
                                    )}
                                </Grid>
                            </Grid>
                        </div>
                    </div>
                }
                EnvironmentFields={
                    <div>
                        <div style={{ flexGrow: 1 }}>
                            <Grid
                                container
                                spacing={2}
                            >
                                <Grid item xs={12}>
                                    {PlatformFormField.GDPRPlatformField(
                                        values,
                                        handleChange,
                                        isGDPR,
                                        classes,
                                        config,
                                        isChecked
                                    )}
                                </Grid>
                                <Grid item xs={3}>
                                    {PlatformFormField.agent_deploymentRegion(
                                        values,
                                        handleChange,
                                        isGDPR,
                                        isDedicated,
                                        isOpenAI,
                                        instanceType,
                                        values.TeamName,
                                        configurationType
                                    )}
                                </Grid>
                                <Grid item xs={6}>
                                    {/* Autonomous Ops does not require or validate Domain Context
                                        Root — using a plain field instead of the shared,
                                        heavily-validated component other platforms use.
                                    {!config ? PlatformFormField.DomainContextRootPlatformFieldClient(
                                        values,
                                        handleChangeRootSuggestions,
                                        isRootExist,
                                        rootExistedHint,
                                        rootWrongFormatHint,
                                        externalClientData,
                                        domainContextRoot,
                                        isLoading
                                    ) : PlatformFormField.DomainContextRootPlatformField(
                                        values,
                                        handleChangeRoot,
                                        isRootExist,
                                        rootExistedHint,
                                        isLoading
                                    )} */}
                                    {FormField2.AODomainContextRoot(handleChange, values)}
                                </Grid>
                                <Grid item xs={3}>
                                    {PlatformFormField.EnvironmentField(values, handleChange, env)}
                                </Grid>
                            </Grid>
                        </div>
                    </div>
                }

                ApplicationFields={
                    <div style={{ flexGrow: 1 }}>
                        <Grid
                            container
                            spacing={2}
                        >
                            {/* ChatGPT / OpenAITextEmbeddingsModel are not used for
                                Autonomous Ops — hidden, but still submitted with
                                default values from AOPFormModel (see FormModels.js).
                            <Grid item xs={6}>
                                {FormField.ChatGPTFieldAO(handleChange, values)}
                            </Grid>
                            <Grid item xs={6}>
                                {FormField.OpenAITextEmbeddingsModel(handleChange, values)}
                            </Grid> */}
                            {isDialogFlow &&
                                <Grid item xs={6}>{FormField.DialogFlowDevTokenField(handleChange, values)}</Grid>}
                            {isDialogFlow &&
                                <Grid item xs={6}>{FormField.DialogFlowClientTokenField(handleChange, values)}</Grid>}
                            <Grid item xs={6}>
                                {FormField.AdminDistributionGroupField(handleChange, values)}
                            </Grid>
                            <Grid item xs={6}>
                                <StyledTooltip
                                    title={longTextEndDate}
                                    placement="left-start"
                                    noValidate
                                >
                                    <DateTextFieldCommonComponent
                                        tentativeServiceEndDate={values.TentativeServiceEndDate}
                                        selectedEnvironment={selectedEnvironment}
                                        isServiceEndDateInvalid={isServiceEndDateInvalid}
                                        minDate={minDate}
                                        maxDate={maxDate}
                                        handleChange={handleChange}
                                        style={{ paddingTop: "10px" }}
                                    />
                                </StyledTooltip>
                            </Grid>
                            <Grid item xs={12}>

                            </Grid>
                            <Grid item xs={12}>
                                <div style={{ fontSize: "1rem", color: '#5f47c9', fontWeight: '600' }}>
                                    <label>
                                        Agent(s)
                                    </label>
                                </div>
                            </Grid>
                            <Grid item xs={12}>
                                <div style={{ fontSize: "small", color: "#c20000" }}>
                                    <em>
                                        <strong>Note:</strong>&nbsp;Some Agent required some Application Core. such as TRA,RCA,CMA,OIA.
                                    </em>
                                </div>
                            </Grid>
                            <Grid item xs={12}>
                                <FormGroup style={{ marginTop: '7px', padding: '0px 5px' }}>
                                    {/* TRA (Ticket Resolver Agent) checkbox hidden for now.
                                        Uncomment this block to bring it back.
                                    <FormControlLabel
                                        style={{ width: '400px', position: 'relative' }}
                                        control={
                                            <Checkbox
                                                checked={(values.Agent).includes('TRA')}
                                                onChange={(e) => handleChange(e, "Agent")}
                                                name="TRA" />
                                        }
                                        label={
                                            <>
                                                Ticket Resolver Agent
                                                <em style={{ marginTop: '1px', fontSize: '.85rem', color: '#8802ee', position: 'absolute', right: '10px' }}>v1.0.0</em>
                                            </>
                                        }
                                    />
                                    */}
                                    <FormControlLabel
                                        style={{ width: '400px', position: 'relative' }}
                                        control={
                                            <Checkbox
                                                checked={(values.Agent).includes('RCA')}
                                                onChange={(e) => handleChange(e, "Agent")}
                                                name="RCA" />
                                        }
                                        label={
                                            <>
                                                Root Cause Analyzer Agent
                                                <em style={{ marginTop: '1px', fontSize: '.85rem', color: '#8802ee', position: 'absolute', right: '10px' }}>v1.0.0</em>
                                            </>
                                        }
                                    />
                                    <FormControlLabel
                                        style={{ width: '400px', position: 'relative' }}
                                        control={
                                            <Checkbox
                                                checked={(values.Agent).includes('CMA')}
                                                onChange={(e) => handleChange(e, "Agent")}
                                                name="CMA" />
                                        }
                                        label={
                                            <>
                                                Certificate Manager Agent
                                                <em style={{ marginTop: '1px', fontSize: '.85rem', color: '#8802ee', position: 'absolute', right: '10px' }}>v1.0.0</em>
                                            </>
                                        }
                                    />
                                    <FormControlLabel
                                        style={{ width: '400px', position: 'relative' }}
                                        control={
                                            <Checkbox
                                                checked={(values.Agent).includes('OID')}
                                                onChange={(e) => handleChange(e, "Agent")}
                                                name="OID" />
                                        }
                                        label={
                                            <>
                                                Observability Agent
                                                <em style={{ marginTop: '1px', fontSize: '.85rem', color: '#8802ee', position: 'absolute', right: '10px' }}>v1.0.0</em>
                                            </>
                                        }
                                    />
                                </FormGroup>
                            </Grid>

                            {/* Shared: CUI + AM — TRA / RCA / OID / CMA */}
                            {hasAnyAgent &&
                                <Grid item xs={12}>
                                    <div style={{ fontSize: '.8rem', color: '#5f47c9', fontWeight: '600' }}>
                                        <label>Instance Details Required</label>
                                    </div>
                                </Grid>
                            }
                            {hasAnyAgent &&
                                <>
                                    <Grid item xs={4}>{FormField2.AOCuiUrl(handleChange, values, isChecking.cuiendpoint, cuiEndpointValid)}</Grid>
                                    <Grid item xs={4}>{FormField2.AOImUsername(handleChange, values)}</Grid>
                                    <Grid item xs={4}>{FormField2.AOImPassword(handleChange, values, showPassword.imPassword, (val) => toggleShowPassword('imPassword', val))}</Grid>
                                    {isTRA &&
                                        <Grid item xs={4}>{FormField2.AOKmUrl(handleChange, values, isChecking.kmendpoint, kmEndpointValid)}</Grid>
                                    }
                                    <Grid item xs={4}>{FormField2.AOAmUrl(handleChange, values, isChecking.amendpoint, amEndpointValid)}</Grid>
                                    {showAmApiKey &&
                                        <Grid item xs={4}>{FormField2.AOAmApikey(handleChange, values, showPassword.amApiKey, (val) => toggleShowPassword('amApiKey', val))}</Grid>
                                    }
                                    {showAmDeploymentType &&
                                        <Grid item xs={4}>
                                            <div style={{ fontSize: '.75rem', color: '#5f47c9', marginBottom: '2px' }}>Agent Manager Deployment Type</div>
                                            {FormField2.AOAmType(handleChange, values)}
                                        </Grid>
                                    }
                                </>
                            }

                            {/* Shared: ServiceNow basic — TRA / RCA / OID / CMA */}
                            {hasAnyAgent &&
                                <>
                                    <Grid item xs={4}>{FormField2.AOSnUrl(handleChange, values)}</Grid>
                                    <Grid item xs={4}>{FormField2.AOSnUsername(handleChange, values)}</Grid>
                                    <Grid item xs={4}>{FormField2.AOSnPassword(handleChange, values, showPassword.snPassword, (val) => toggleShowPassword('snPassword', val))}</Grid>
                                </>
                            }

                            {/* TRA only: Ticket Source */}
                            {isTRA &&
                                <>
                                    <Grid item xs={12}>
                                        <div style={{ fontSize: '.8rem', color: '#5f47c9', fontWeight: '600' }}>
                                            <label>Ticket Resolver Agent</label>
                                        </div>
                                    </Grid>
                                    <Grid item xs={4}>{FormField2.AOTsUrl(handleChange, values)}</Grid>
                                    <Grid item xs={4}>{FormField2.AOTsUsername(handleChange, values)}</Grid>
                                    <Grid item xs={4}>{FormField2.AOTsPassword(handleChange, values, showPassword.tsPassword, (val) => toggleShowPassword('tsPassword', val))}</Grid>
                                </>
                            }

                            {/* RCA only: Snow MCP extension + Splunk MCP + Build Artifact Storage */}
                            {(isRCA) &&
                                <>
                                    <Grid item xs={12}>
                                        <div style={{ fontSize: '.8rem', color: '#5f47c9', fontWeight: '600' }}>
                                            <label>Root Cause Analyzer Agent</label>
                                        </div>
                                    </Grid>
                                    <Grid item xs={4}>{FormField2.AOAgentCollection(handleChange, values)}</Grid>
                                    <Grid item xs={4}>{FormField2.AOConfigSource(handleChange, values)}</Grid>
                                    <Grid item xs={4}>{FormField2.AORCATeamId(handleChange, values)}</Grid>
                                    <Grid item xs={4}>{FormField2.AOAmWorkSpaceId(handleChange, values)}</Grid>

                                    <Grid item xs={12}>
                                        <div style={{ fontSize: '.75rem', color: '#5f47c9', fontWeight: '600' }}>
                                            <label>ServiceNow (MCP)</label>
                                        </div>
                                    </Grid>
                                    <Grid item xs={4}>{FormField2.AOSnowMCPUrl(handleChange, values)}</Grid>
                                    <Grid item xs={4}>{FormField2.AOSnowLLMConfig(handleChange, values)}</Grid>
                                    <Grid item xs={4}>{FormField2.AOSnowProtocolVersion(handleChange, values)}</Grid>

                                    <Grid item xs={12}>
                                        <div style={{ fontSize: '.75rem', color: '#5f47c9', fontWeight: '600' }}>
                                            <label>Splunk (MCP)</label>
                                        </div>
                                    </Grid>
                                    <Grid item xs={4}>{FormField2.AOSplunkMCPUrl(handleChange, values)}</Grid>
                                    <Grid item xs={4}>{FormField2.AOSplunkServiceName(handleChange, values)}</Grid>
                                    <Grid item xs={4}>{FormField2.AOSplunkToken(handleChange, values, showPassword.splunkToken, (val) => toggleShowPassword('splunkToken', val))}</Grid>
                                    <Grid item xs={4}>{FormField2.AOSplunkLLMConfig(handleChange, values)}</Grid>

                                    <Grid item xs={12}>
                                        <div style={{ fontSize: '.8rem', color: '#5f47c9', fontWeight: '600' }}>
                                            <label>Build Artifact Storage</label>
                                        </div>
                                    </Grid>
                                    <Grid item xs={4}>{FormField2.AOArtifactUpload(handleChange, values)}</Grid>
                                    <Grid item xs={4}>{FormField2.AOArtifactS3Bucket(handleChange, values)}</Grid>
                                    <Grid item xs={4}>{FormField2.AOArtifactS3Prefix(handleChange, values)}</Grid>
                                    <Grid item xs={4}>{FormField2.AOArtifactAzStorageAccount(handleChange, values)}</Grid>
                                    <Grid item xs={4}>{FormField2.AOArtifactAzContainer(handleChange, values)}</Grid>
                                    <Grid item xs={4}>{FormField2.AOArtifactAzPrefix(handleChange, values)}</Grid>
                                </>
                            }

                            {/* CMA only: Venafi + AWX/Ansible */}
                            {(isCMA) &&
                                <>
                                    <Grid item xs={12}>
                                        <div style={{ fontSize: '.8rem', color: '#5f47c9', fontWeight: '600' }}>
                                            <label>Certificate Manager Agent</label>
                                        </div>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <div style={{ fontSize: '.75rem', color: '#5f47c9', fontWeight: '600' }}>
                                            <label>Venafi</label>
                                        </div>
                                    </Grid>
                                    <Grid item xs={4}>{FormField2.AOVenafiUrl(handleChange, values)}</Grid>
                                    <Grid item xs={4}>{FormField2.AOVenafiApikey(handleChange, values, showPassword.venafiApiKey, (val) => toggleShowPassword('venafiApiKey', val))}</Grid>

                                    <Grid item xs={12}>
                                        <div style={{ fontSize: '.75rem', color: '#5f47c9', fontWeight: '600' }}>
                                            <label>AWX / Ansible</label>
                                        </div>
                                    </Grid>
                                    <Grid item xs={4}>{FormField2.AOAwxUrl(handleChange, values)}</Grid>
                                    <Grid item xs={4}>{FormField2.AOAwxUsername(handleChange, values)}</Grid>
                                    <Grid item xs={4}>{FormField2.AOAwxPassword(handleChange, values, showPassword.awxPassword, (val) => toggleShowPassword('awxPassword', val))}</Grid>
                                    <Grid item xs={4}>{FormField2.AOAwxJobTemplateId(handleChange, values)}</Grid>
                                    <Grid item xs={4}>{FormField2.AOAwxTargetHost(handleChange, values)}</Grid>
                                    <Grid item xs={4}>{FormField2.AOAwxTargetUser(handleChange, values)}</Grid>
                                    <Grid item xs={4}>{FormField2.AOAwxTimeout(handleChange, values)}</Grid>
                                </>
                            }
                            {/* OID only: source selection, CMDBLite, Datadog, Dynatrace,
                                Elasticsearch, SLO, Splunk (plain triad), Build Artifact Storage */}
                            {(isOID) &&
                                <>
                                    <Grid item xs={12}>
                                        <div style={{ fontSize: '.8rem', color: '#5f47c9', fontWeight: '600' }}>
                                            <label>Observability Agent</label>
                                        </div>
                                    </Grid>
                                    <Grid item xs={4}>{FormField2.AOOidSources(handleChange, values)}</Grid>

                                    <Grid item xs={12}>
                                        <div style={{ fontSize: '.75rem', color: '#5f47c9', fontWeight: '600' }}>
                                            <label>Splunk</label>
                                        </div>
                                    </Grid>
                                    <Grid item xs={4}>{FormField2.AOSplunkUrl(handleChange, values)}</Grid>
                                    <Grid item xs={4}>{FormField2.AOSplunkUsername(handleChange, values)}</Grid>
                                    <Grid item xs={4}>{FormField2.AOSplunkPassword(handleChange, values, showPassword.splunkPassword, (val) => toggleShowPassword('splunkPassword', val))}</Grid>

                                    <Grid item xs={12}>
                                        <div style={{ fontSize: '.75rem', color: '#5f47c9', fontWeight: '600' }}>
                                            <label>CMDBLite</label>
                                        </div>
                                    </Grid>
                                    <Grid item xs={4}>{FormField2.AOCmdbUrl(handleChange, values)}</Grid>
                                    <Grid item xs={4}>{FormField2.AOCmdbUsername(handleChange, values)}</Grid>
                                    <Grid item xs={4}>{FormField2.AOCmdbPassword(handleChange, values, showPassword.cmdbPassword, (val) => toggleShowPassword('cmdbPassword', val))}</Grid>

                                    <Grid item xs={12}>
                                        <div style={{ fontSize: '.75rem', color: '#5f47c9', fontWeight: '600' }}>
                                            <label>Datadog</label>
                                        </div>
                                    </Grid>
                                    <Grid item xs={4}>{FormField2.AODatadogUrl(handleChange, values)}</Grid>
                                    <Grid item xs={4}>{FormField2.AODatadogUsername(handleChange, values)}</Grid>
                                    <Grid item xs={4}>{FormField2.AODatadogPassword(handleChange, values, showPassword.datadogPassword, (val) => toggleShowPassword('datadogPassword', val))}</Grid>

                                    <Grid item xs={12}>
                                        <div style={{ fontSize: '.75rem', color: '#5f47c9', fontWeight: '600' }}>
                                            <label>Dynatrace</label>
                                        </div>
                                    </Grid>
                                    <Grid item xs={4}>{FormField2.AODynatraceUrl(handleChange, values)}</Grid>
                                    <Grid item xs={4}>{FormField2.AODynatraceUsername(handleChange, values)}</Grid>
                                    <Grid item xs={4}>{FormField2.AODynatracePassword(handleChange, values, showPassword.dynatracePassword, (val) => toggleShowPassword('dynatracePassword', val))}</Grid>

                                    <Grid item xs={12}>
                                        <div style={{ fontSize: '.75rem', color: '#5f47c9', fontWeight: '600' }}>
                                            <label>Elasticsearch</label>
                                        </div>
                                    </Grid>
                                    <Grid item xs={4}>{FormField2.AOElasticUrl(handleChange, values)}</Grid>
                                    <Grid item xs={4}>{FormField2.AOElasticUsername(handleChange, values)}</Grid>
                                    <Grid item xs={4}>{FormField2.AOElasticPassword(handleChange, values, showPassword.elasticPassword, (val) => toggleShowPassword('elasticPassword', val))}</Grid>

                                    <Grid item xs={12}>
                                        <div style={{ fontSize: '.75rem', color: '#5f47c9', fontWeight: '600' }}>
                                            <label>SLO</label>
                                        </div>
                                    </Grid>
                                    <Grid item xs={4}>{FormField2.AOSloUrl(handleChange, values)}</Grid>
                                    <Grid item xs={4}>{FormField2.AOSloUsername(handleChange, values)}</Grid>
                                    <Grid item xs={4}>{FormField2.AOSloPassword(handleChange, values, showPassword.sloPassword, (val) => toggleShowPassword('sloPassword', val))}</Grid>

                                    <Grid item xs={12}>
                                        <div style={{ fontSize: '.75rem', color: '#5f47c9', fontWeight: '600' }}>
                                            <label>Build Artifact Storage</label>
                                        </div>
                                    </Grid>
                                    <Grid item xs={4}>{FormField2.AOArtifactUpload(handleChange, values)}</Grid>
                                    <Grid item xs={4}>{FormField2.AOArtifactS3Bucket(handleChange, values)}</Grid>
                                    <Grid item xs={4}>{FormField2.AOArtifactS3Prefix(handleChange, values)}</Grid>
                                    <Grid item xs={4}>{FormField2.AOArtifactAzStorageAccount(handleChange, values)}</Grid>
                                    <Grid item xs={4}>{FormField2.AOArtifactAzContainer(handleChange, values)}</Grid>
                                    <Grid item xs={4}>{FormField2.AOArtifactAzPrefix(handleChange, values)}</Grid>
                                </>
                            }

                        </Grid>
                    </div>
                }
                LeftColumnFields={
                    <div>
                    </div>
                }
                RightColumnFields={
                    <div>
                    </div>
                }
                history={history}
                productname={'AutonomousOps'}
            ></GeneralForm>

            {/* Validation Error Dialog */}
            <ValidationDialog
                open={showValidationDialog}
                onClose={closeDialog}
                errors={validationErrors}
            />

            {!isChecked && (
                <CommonDialogV2
                    open={isNoteVisible}
                    onClose={() => setNoteVisible(false)}
                    title={"Note"}
                    textContent={
                        <div>
                            <div style={{ textAlign: 'center', fontSize: '1.1em', fontWeight: '500' }}>If a valid contract is not provided within the 4-week period</div>
                            <ul>
                                <li>
                                    Provisioned services will be automatically stopped
                                </li>
                                <li>
                                    Cost recovery will be initiated using the provided WBSE code
                                </li>
                            </ul>
                        </div>
                    }
                    dialogActions={
                        <DialogActions >
                            <AcceptButton2 onClick={() => setNoteVisible(false)} label={"Ok"} />
                        </DialogActions>
                    }
                ></CommonDialogV2>
            )}
        </>
    );
};

const MSTP = (state, ownProps) => ({
    values: state.fui.AOPForm,
    isRootExist: state.fui.isRootExist,
    isWBSEValid: state.fui.isWBSEValid,
    configurationType: state.fui.configurationType,
    email: state.auth.userDetails.email,
    idToken: state.auth.idToken,
    externalClientData: state.fui.externalClientData,
    externalClientError: state.fui.externalClientError,
    isExternalClientLoading: state.fui.isExternalClientLoading,
    isLoading: state.fui.isLoading,
});

export default connect(MSTP, {
    checkDomainAvaliable: checkRootExisted,
    updateAOPForm: fuiRedux.updateAOPForm,
    fetchExternalClientDetails,
    checkIsWBSEValid
})(withRouter(AutonomousOps));